import React, { useState, useContext, useEffect } from "react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { NavigationContext } from "navigation-react";
import LoaderAnimation from "./LoaderAnimationLarge";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: "aes" });

const EditUserRegister = () => {
  const { data, stateNavigator } = useContext(NavigationContext);
  const [loading, setLoading] = useState(false);
  const [usermail, setuserMail] = useState(data?.userEmail || "");
  const [username, setusername] = useState(data?.userName || "");
  const [userfullname, setuserfullname] = useState(
    data?.userDoctorFullName || ""
  );
  const [userphonenumber, setuserphonenumber] = useState(
    data?.userDoctorContactNumber || ""
  );
  const [userspecialty, setuserspecialty] = useState(data?.userSpecialty || "");

  useEffect(() => {
    console.log("data?.userspecialty:::", data?.userSpecialty);
  }, [data?.userSpecialty, data.userspecialty]);

  const [userStatus, setuserStatus] = useState("1" || "0");

  const [usercurrentpass, setusercurrentpass] = useState("");
  console.log("STATUS:", data?.userStatus);

  const username1 = ls.get("username");
  const userpw = ls.get("userpw");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const dataFields = {
        field_doctor_referer_full_name: [{ value: userfullname }],
        field_doctor_ref_contact_number: [{ value: userphonenumber }],
        field_specialty: [{ value: userspecialty }],
        mail: [{ value: usermail }],
        name: [{ value: username }],
        roles: [{ target_id: "content_editor" }],
        status: [{ value: userStatus }],
        pass: [{ value: usercurrentpass, existing: usercurrentpass }],
      };

      const response = await fetch(`/user/${data.userId}?_format=json`, {
        method: "PATCH",
        credentials: "same-origin",
        mode: "same-origin",
        headers: {
          Authorization: `Basic ${btoa(`${username1}:${userpw}`)}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataFields),
      });

      if (response.ok) {
        setLoading(false);
        stateNavigator.navigate("userregister");
        alert("User edited successfully!");
      } else {
        setLoading(false);
        const error = await response.json();
        alert(`Error Edit User: ${error.message}`);
        console.log("Error Edit User:", error.message);
      }
    } catch (error) {
      setLoading(false);
      alert(`Network Error`);
    }
  };

  if (loading) {
    return <LoaderAnimation />;
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="add-patient-register">
          <TopActionMenus
            AddTitle={`Editing: ${data?.userDoctorFullName} details`}
            backIcon={faArrowLeft}
            backLable="Back"
            backStateKey="userregister"
          />
          <form onSubmit={handleSubmit} className="patient-form">
            <div className="form-group">
              <label htmlFor="title">Full Name</label>
              <input
                type="text"
                value={userfullname}
                onChange={(e) => setuserfullname(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="field_user_phone_number">Contact Number</label>
              <input
                type="tel"
                value={userphonenumber}
                onChange={(e) => setuserphonenumber(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="field_user_specialty">Specialty</label>
              <input
                type="text"
                placeholder="Enter specialty"
                value={userspecialty}
                onChange={(e) => setuserspecialty(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="field_user_name">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setusername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="field_user_email_address">Email Address</label>
              <input
                type="email"
                placeholder=" Enter user email address"
                value={usermail}
                onChange={(e) => setuserMail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="field_status">Status</label>
              <select
                id="userStatus"
                value={userStatus}
                onChange={(e) => setuserStatus(e.target.value)}
                required
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="field_user_password">Change Password</label>
              <input
                type="password"
                placeholder="Enter your current password"
                value={usercurrentpass}
                onChange={(e) => setusercurrentpass(e.target.value)}
                // required
              />
              <p className="fomdescription">
                Please note: This field is optional. Change it only if you want
                to set a new password; otherwise, you can submit the form as it
                is.
              </p>
            </div>

            <div className="submitGroup">
              <button type="submit" disabled={loading}>
                {"Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <DashboardContentFooter />
    </div>
  );
};

export default EditUserRegister;
